import { generatedId } from './helper';

const sprintIssues = {
  name: 'Sprint March 1',
  type: 'sprint',
  id: generatedId(),
  objective: 'Create an MVP for the review of stackholders',
  startDate: '',
  endDate: '',
  duration: '',
  issues: [],
};

const backlogIssues = {
  name: 'Backlog',
  type: 'backlog',
  id: generatedId(),
  issues: [],
};

export const fullData = [sprintIssues, backlogIssues];
export const structuredData = [
  { ...sprintIssues, issues: [] },
  { ...backlogIssues, issues: [] },
];
